import { Component } from "react";

class Pages extends Component{
    
}

export default Pages;